(function() {
  'use strict';

  function initBreadcrumbBackButton() {
    const backButton = document.querySelector('.breadcrumb-back-btn');
    
    if (backButton) {
      backButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBreadcrumbBackButton);
  } else {
    initBreadcrumbBackButton();
  }
})();
